'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quickQuoteStyle = undefined;
var _themes = require('@marmalade/themes');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var quickQuoteStyle = exports.quickQuoteStyle = function quickQuoteStyle() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return _themes.createThemeStyle.apply(undefined, ['LDIQuickQuote'].concat(styles));
};
var createTheme = function createTheme(baseTheme) {
  return Object.assign(_defineProperty({}, quickQuoteStyle('Icon_color'), baseTheme.colorPrimary), baseTheme);
};
exports.default = createTheme;